import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../helpers/common'
import { register } from '../../../helpers/reducerRegistry'
import { getAllIdChecked } from '../../tree/helper'
import { convertTreeData } from '../filterSetting/helper'
import { getVSIC } from './thunk'

const initialState = {
  isLoading: {
    vsic: false,
  },
  industry: {
    industryVSIC: {},
    industryVSICById: {},
    listParentChecked: [],
    listChecked: [],
  },
}

const slice = createSlice({
  name: 'common/filterCompany/industry',
  initialState,
  reducers: {
    resetStoreIndustry: () => initialState,
    selectListId(state, action) {
      state.industry.listChecked = action.payload
    },
    changeListParentChecked(state, action) {
      state.industry.listParentChecked = action.payload
    },
    handelRemoveIdParent(state, action) {
      state.industry.listParentChecked =
        state.industry.listParentChecked.filter(
          (item) => item !== action.payload,
        )
    },
    convertDataIndustrySelectById(state, action) {
      state.industry.listParentChecked = action.payload
      state.industry.listChecked = getAllIdChecked(
        state.industry.industryVSIC,
        'id',
        action.payload,
      )
    },
    resetIndustry(state) {
      state.industry.listParentChecked = []
      state.industry.listChecked = []
    },
  },
  extraReducers: (builder) => {
    //getVSIC
    builder.addCase(getVSIC.pending, (state) => {
      state.isLoading.vsic = true
    })
    builder.addCase(getVSIC.fulfilled, (state, action) => {
      state.industry.industryVSIC = convertTreeData(action.payload)
      state.industry.industryVSICById = keyBy(action.payload, 'id')
      state.isLoading.vsic = false
    })
    builder.addCase(getVSIC.rejected, (state, action) => {
      state.isLoading.vsic = action.payload.loading
    })
  },
})

export const loadingIndustry = (state) => state[slice.name].isLoading.vsic

export const selectIndustry = (type) => (state) =>
  type ? state[slice.name].industry[type] : state[slice.name].industry

export const selectVsicById = (id, attr) => (state) => {
  if (!id) return state[slice.name].industry.industryVSICById
  const data = state[slice.name].industry.industryVSICById[id]
  return data && attr ? data[attr] : data
}

export const {
  resetStoreIndustry,
  changeListParentChecked,
  handelRemoveIdParent,
  selectListId,
  resetIndustry,
  convertDataIndustrySelectById,
} = slice.actions

register(slice.name, slice.reducer)
